/*
 * @Author: your name
 * @Date: 2021-11-23 09:54:16
 * @LastEditTime: 2021-12-06 14:39:55
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\components\payment-detail-table\constant.ts
 */

export const columns = [
  {
    title: "#",
    width: 60,
    slots: { customRender: "index" },
  },
  {
    title: "收款单号",
    width: 150,
    dataIndex: "receiptBizNo",
    key: "receiptBizNo",
  },
  {
    title: "收款日期",
    width: 150,
    dataIndex: "collectionDate",
    key: "collectionDate",
  },
  {
    title: "收款金额(￥)",
    width: 200,
    dataIndex: "currentCollectionAmount",
    key: "currentCollectionAmount",
  },
  // {
  //   title: "为本票核销金额(￥)",
  //   width: 250,
  //   dataIndex: "currentWrittenOff",
  //   key: "currentWrittenOff",
  // },
  {
    title: "备注",
    dataIndex: "remark",
    key: "remark",
  },
];
